import React from "react";

const Text = () => {
  return (
    <div>
      <section className="w-[90%] md:w-[74%] mx-auto my-20 text-lg text-justify flex flex-col gap-2">
        <h3>
          <b>Welcome to the Animal Kingdom Park!</b>
        </h3>
        <p>
          Our Animal Kingdom Park is a captivating destination that celebrates
          the wonders of the animal kingdom. Immerse yourself in a world of
          breathtaking beauty, diverse ecosystems, and extraordinary creatures
          from all corners of the globe. Whether you're a nature enthusiast, an
          animal lover, or simply seeking a unique and educational experience,
          our park offers something for everyone.
        </p>
        <p>
          Discover a captivating collection of habitats meticulously designed to
          provide a comfortable and natural environment for our diverse range of
          animal residents. From the dense jungles of the Amazon to the vast
          savannahs of Africa, each exhibit faithfully recreates the native
          surroundings of its inhabitants, allowing you to observe these
          magnificent creatures up close.
        </p>
        <p>
          Embark on an unforgettable journey as you encounter iconic species
          such as lions, elephants, tigers, gorillas, and many more. Marvel at
          their power, grace, and intelligence as you learn about their natural
          behaviors, conservation efforts, and the challenges they face in the
          wild.
        </p>
        <p>
          For the younger adventurers, our park offers an array of fun and
          educational activities. From animal-themed playgrounds to interactive
          exhibits and wildlife-themed shows, children will be enthralled by the
          wonders of the animal kingdom, fostering a lifelong love for nature
          and its incredible creatures.
        </p>
        <p>
          To enhance your visit, indulge in our array of dining options,
          offering delicious cuisine inspired by various cultures from around
          the world. Browse through our gift shops to find unique souvenirs,
          eco-friendly merchandise, and educational materials to remember your
          visit by.
        </p>
        <p>
          Join us at the Animal Kingdom Park, where the majesty of nature and
          the fascination of the animal kingdom come alive. Explore, learn, and
          be inspired as you embark on an adventure that celebrates the
          diversity and beauty of our planet's extraordinary creatures. We look
          forward to sharing this unforgettable experience with you and creating
          memories that will last a lifetime.
        </p>
      </section>
    </div>
  );
};

export default Text;
